module.exports = __webpack_public_path__ + "statics/img/4-4.59a1802.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/product/icon/4-4.png
// module id = Dp8g
// module chunks = 1